import { useEffect, useState } from "react"

interface AppConfig {
  googleMapsApiKey?: string
}

let configCache: AppConfig | null = null

export function useConfig() {
  const [config, setConfig] = useState<AppConfig>({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (configCache) {
      setConfig(configCache)
      setIsLoading(false)
      return
    }

    const fetchConfig = async () => {
      try {
        const response = await fetch(`/api/config`)
        if (response.ok) {
          const data = await response.json()
          configCache = data
          setConfig(data)
        }
      } catch (error) {
        console.error(`[useConfig] Failed to fetch config:`, error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchConfig()
  }, [])

  return { config, isLoading }
}
